import React from "react"
import { useNavigate } from "react-router-dom"
import { BaseHeader, headerButtonProps } from "../components/BaseHeader"
import { Button } from "@mantine/core"

const AdminHeaderContainer = () => {
  const navigate = useNavigate()

  return (
    <BaseHeader>
      <Button {...headerButtonProps} onClick={() => navigate('/admin/login')}>
        ログイン
      </Button>
    </BaseHeader>
  )
}

export default AdminHeaderContainer
